import { render, staticRenderFns } from "./DinasTahapTes.vue?vue&type=template&id=41448bec"
import script from "./DinasTahapTes.vue?vue&type=script&lang=js"
export * from "./DinasTahapTes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports